import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from './Reveal';
export function VideoPreview() {
  return <section className="w-full bg-navy-50/30 py-20 sm:py-28 overflow-hidden pt-[1px] pb-[0px]" data-id="element-567" data-mp="31w1tddr8afun">
      <div className="mx-auto w-full max-w-4xl px-5 sm:px-8" data-id="element-568" data-mp="36t20lrztdonc">
        <Reveal className="text-center" data-id="element-569" data-mp="3bkjrtoc1cav4">
          <span className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 font-display text-xs font-extrabold uppercase tracking-[0.14em] text-navy shadow-sm" data-id="element-570" data-mp="3bllhaxtsszwd">
            ▶ MIRÁ CÓMO FUNCIONA
          </span>
          <h2 className="mt-6 text-3xl font-black leading-tight text-navy sm:text-5xl font-[Barlow,_sans-serif]" data-id="element-571" data-mp="3ll3y55eew5k7">
            Un video, un proyecto
            <br data-id="element-572" data-mp="3ujxqgjkpm9ry" />
            <span className="text-orange" data-id="element-573" data-mp="3uimjkavywlwm">y muchas ganas de crear.</span>
          </h2>
        </Reveal>

        <div className="relative mx-auto mt-16 max-w-[280px] sm:max-w-[320px]" data-id="element-574" data-mp="1v7v8xevnbpgx">
          {/* Floating Phone Container */}
          <motion.div animate={{
          y: [0, -15, 0]
        }} transition={{
          duration: 6,
          repeat: Infinity,
          ease: "easeInOut"
        }} className="relative z-10 aspect-[9/19] w-full overflow-hidden rounded-[2.5rem] border-[8px] border-navy bg-navy shadow-2xl sm:rounded-[3rem] sm:border-[12px]" data-id="element-575" data-mp="205wq1u9ihepr">
            {/* Phone Notch */}
            <div className="absolute top-0 left-1/2 z-20 h-6 w-1/3 -translate-x-1/2 rounded-b-2xl bg-navy sm:h-7" data-id="element-576" data-mp="2u7bopovd1gin"></div>
            
            {/* Video */}
            <video src="https://cdn.magicpatterns.com/uploads/sRXjKobDiBKF5fomxLVHzb/0728.mp4" className="h-full w-full object-cover" autoPlay loop muted playsInline data-id="element-577" data-mp="3qugl0f2ni0iw" />
          </motion.div>

          {/* Floating Badges */}
          <motion.div animate={{
          y: [0, -8, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 1
        }} className="absolute -left-12 top-1/4 z-20 sm:-left-24 sm:top-1/3" data-id="element-578" data-mp="3cxjllp8gvaqe">
            <span className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2.5 font-display text-xs font-extrabold text-navy shadow-xl sm:text-sm" data-id="element-579" data-mp="21ga61dsgl2ud">
              <span aria-hidden="true" className="text-orange" data-id="element-580" data-mp="27yd93lzwmnmg">🤖</span> Paso a paso
            </span>
          </motion.div>

          <motion.div animate={{
          y: [0, 8, 0]
        }} transition={{
          duration: 5,
          repeat: Infinity,
          ease: "easeInOut",
          delay: 0.5
        }} className="absolute -right-8 bottom-1/4 z-20 sm:-right-20 sm:bottom-1/3" data-id="element-581" data-mp="1txkfr4lc9ykx">
            <span className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2.5 font-display text-xs font-extrabold text-navy shadow-xl sm:text-sm" data-id="element-582" data-mp="1oyzcewasiys9">
              <span aria-hidden="true" className="text-orange" data-id="element-583" data-mp="1b9p2rmxjwosv">🧠</span> Aprende jugando
            </span>
          </motion.div>
          
          {/* Decorative background blur */}
          <div className="absolute top-1/2 left-1/2 -z-10 h-3/4 w-3/4 -translate-x-1/2 -translate-y-1/2 rounded-full bg-orange-100/50 blur-3xl" data-id="element-584" data-mp="11a6p1o88hz99"></div>
        </div>
      </div>
    </section>;
}